import React, { useEffect, useState } from 'react';

import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';


import { useNavigate } from "react-router-dom";
import { Loader } from '../../components/utils';

import { DataGrid } from '@mui/x-data-grid';
import {

  ViewButtonStyle,
  ViewonBlur,
  ViewonFocus,
  ViewonMouseEnter,
  ViewonMouseLeave,
  localeTextGrid,
} from "../../constants";
import { ThemeProvider, createTheme } from '@mui/material';
import { useStateContext } from '../../context/ContextProvider';

import {truncateTitle} from "../../middleware/truncateTitle"
import { Button } from "@mui/material";


import { getUserCases } from '../../redux/actions/cases';
function UAllCases() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { currentDir } = useStateContext();
  const [isSpinner, setIsSpinner] = useState(false);
  const [caseNumber, setCaseNumber] = useState();
  const [clientName, setClientName] = useState("");
  const [opponentName, setOpponentName] = useState("");

  const [nextSessionDate ,setNextSessionDate]=useState()
  const [caseType,setCaseType ] = useState("");
  const [courtType, setCourtType] = useState("");
  const [courtName, setCourtName] = useState("");
  const navigate = useNavigate();
  const [paginationModel, setPaginationModel] = useState({
    pageSize: 10,
    page: 0,
  });

  const page = paginationModel.page;
  const limit = paginationModel.pageSize;


  useEffect(() => {
   
    dispatch(getUserCases(page, limit, ));
  }, [page, limit]);

  const { isLoading, UserCases, paginationCase } = useSelector((state) => state.Cases);




const ViewCaseHandeler=(id) =>{
  navigate(`/userCaseDetails/${id}`);
}
  const theme = createTheme({
    direction: currentDir
  });

  const totalPages = paginationCase?.totalPages || 0;
  const totalItems = paginationCase?.totalItems || 0; // إضافة هذا إذا كان الخادم يعيد إجمالي العناصر
  const columns = [
    {
      field: "caseNumber",
      headerName: t("case Number"),
      headerClassName: 'font-semibold text-sm font-kufi',
      width: 120,
      filterable: false,
      renderCell: (params) => {
        return (
          <div className="flex items-center pt-4">
            <p className="font-medium text-sm font-kufi">{params.value}</p>
          </div>
        )
      }
    },
    {
      field: 'caseType',
      headerName: t("case Type"),
      headerClassName: 'font-semibold text-sm font-kufi',
      width: 120,
      filterable: false,
      renderCell: (params) => {
        return (
          <div className="flex items-center pt-4">
                <p className="font-medium text-sm font-kufi">{truncateTitle(params.value , 3)}</p>
          </div>
        )
      }
    },
   

    {
      field: 'clientName',
      headerName:  t("client Name") ,
      headerClassName: 'font-semibold text-sm font-kufi',
      width: 200,
   
      filterable: false,
      renderCell: (params) => {
        return (
          <div className="flex items-center">
            <p className="font-kufi">{truncateTitle(params.value,3)} </p>
          </div>
        )
      }
    },
    {
      field: 'opponentName',
      headerName:  t("opponant Name") ,
      headerClassName: 'font-semibold text-sm font-kufi',
      width: 200,
   
      filterable: false,
      renderCell: (params) => {
        return (
          <div className="flex items-center">
            <p className="font-kufi">{params.value} </p>
          </div>
        )
      }
    },
    {
      field: 'courtType',
      headerName:  t("court Type") ,
      headerClassName: 'font-semibold text-sm font-kufi',
      width: 120,
   
      filterable: false,
      renderCell: (params) => {
        return (
          <div className="flex items-center">
            <p className="font-kufi">{params.value} </p>
          </div>
        )
      }
    },
    {
      field: 'courtName',
      headerName:  t("court Name") ,
      headerClassName: 'font-semibold text-sm font-kufi',
      width: 120,
   
      filterable: false,
      renderCell: (params) => {
        return (
          <div className="flex items-center">
            <p className="font-kufi">{params.value} </p>
          </div>
        )
      }
    },
    {
      field: 'nextSessionDate',
      headerName:  t("next Session Date") ,
      headerClassName: 'font-semibold text-sm font-kufi',
      width: 180,
   
      filterable: false,
      renderCell: (params) => {
        return (
          <div className="flex items-center">
            <p className="font-kufi">{params.value} </p>
          </div>
        )
      }
    },
    {
      field: 'actions',
      headerName: t('Actions') ,
      headerClassName: 'font-semibold text-sm font-kufi',
      width: 225,
      filterable: false, // تعطيل الفلتر لهذا العمود
      renderCell: (params) => {
        return (<>
   <div className="flex pt-2 w-[150px] gap-2 items-center ">
  

         <Button className="rounded-full"
        style={ViewButtonStyle}
        onMouseEnter={ViewonMouseEnter}
        onMouseLeave={ViewonMouseLeave}
        onFocus={ViewonFocus}
        onBlur={ViewonBlur} 
        onClick={() => ViewCaseHandeler(params.row._id)}
        >
         <span className='body-2'>{t("View")}</span> 
</Button> 
   </div>
        
         </>
        );
      }
    },
  ];



  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (

        <div className="flex-col  lg:p-16 py-14 px-5 w-full items-center ">
        <h2 className="h2 text-color-1 text-center  dark:text-tcolor-1 mb-4 md:mb-8">{t("All Cases")}</h2>
         
            <div className=" items-center  relative justify-center  md:m-10 mt-24 p-2 md:p-10 h-auto bg-white rounded-3xl">
  <ThemeProvider theme={theme}>
    <div style={{ width: '100%', overflowX: 'auto' }}>
                <DataGrid
                  rows={UserCases}
                  columns={columns}
                  disableRowSelectionOnClick
                  sx={{ minWidth: '1300px' }}     
                  pagination
                  paginationMode="server"
                  rowCount={totalItems} // Total number of items
                  paginationModel={paginationModel}
                  onPaginationModelChange={setPaginationModel}
                  pageSizeOptions={[paginationModel.pageSize]}
                  getRowId={(row) => row._id} // Use _id as the unique identifier
                  localeText={localeTextGrid} // تمرير الترجمات
                />
             </div>
  </ThemeProvider>
</div></div>
      )}
    </>
  );
}

export default UAllCases;